function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}><title>down-arrow</title><g transform="matrix(0 -1 -1 0 25 25)" fill="none" fillRule="evenodd"><circle stroke="#D7DBE9" fill="#F6F7FB" cx="12" cy="12" r="12" /><path d="M8.16 12.3c0-.157.051-.263.154-.367l5.4-5.513c.206-.21.566-.21.823 0 .206.21.206.578 0 .84l-5.04 5.04 4.989 5.093c.205.21.205.577 0 .84-.206.262-.566.21-.823 0L8.314 12.72a.603.603 0 0 1-.154-.42z" fill="#6A6D7B" fillRule="nonzero" /></g></svg>;
});